import React, { FunctionComponent } from 'react';
import Helmet from 'react-helmet';
import getMenuOption from '@app/hooks/useMenuConfig/getMenuOption';
import TopMenuItemConfig from '../TopMenu/types';

export const CATALOG_TITLE_TEMPLATE = `%s`;

export interface CatalogMetaProps {
  menu: TopMenuItemConfig[];
  menuSlugs: string[];
}

const CatalogMeta: FunctionComponent<CatalogMetaProps> = ({
  menu,
  menuSlugs,
}) => {
  const menuItem = getMenuOption(menu, menuSlugs);
  const menuItemMeta = menuItem?.meta || ({} as TopMenuItemConfig['meta']);
  const categoryTitle = menuItemMeta.title || menuItem?.title || '';
  const categoryMeta = menuItemMeta.description;
  const categoryMetaImage = menuItemMeta.image;
  const categoryMetaImageAlt = menuItemMeta.imageAlt;

  return (
    <Helmet titleTemplate={CATALOG_TITLE_TEMPLATE} title={categoryTitle}>
      {categoryMeta && <meta name="description" content={categoryMeta} />}
      {categoryTitle && <meta property="og:title" content={categoryTitle} />}
      {categoryMeta && (
        <meta property="og:description" content={categoryMeta} />
      )}
      {categoryMetaImage && (
        <meta property="og:image" content={categoryMetaImage} />
      )}
      {categoryMetaImageAlt && (
        <meta property="og:image:alt" content={categoryMetaImageAlt} />
      )}
    </Helmet>
  );
};

export default CatalogMeta;
